import React from "react";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

function Features() {
  return (
    <section
      id="features"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div className="container">
        <h2 className="text-9 fw-600 text-center">Onde e para quem vender?</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-5">
          O mercado de atuação é enorme
        </p>
        <div className="row">
          <div className="col-lg-4 align-self-stretch">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>⁠Motoristas autônomos</h3>
                  <p>
                    transporte coletivo e escolar, de transporte de emergência, transporte de produtos perigos e cargas indivisíveis.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>⁠Empresas de transporte e logística</h3>
                  <p>
                    frotistas, transportadoras, cooperativas.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>⁠Prefeituras e órgãos públicos</h3>
                  <p>
                    treinamento de servidores e projetos de educação no trânsito.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>⁠Empresas privadas com frota própria</h3>
                  <p>
                    indústrias, comércio, distribuidoras, empresas de energia, telecom, gás.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>Empresas ou profissionais que trabalham com recursos de multas</h3>
                  <p>
                    empresas, advogados ou especialistas que atuam com elaboração de recursos de multas de Trânsito.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 align-self-stretch">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>⁠Autoescolas e despachantes de trânsito</h3>
                  <p>
                    parceiros estratégicos que já atendem esse público.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3> ⁠Sindicatos e associações de motoristas</h3>
                  <p>
                    ônibus, vans, carga leve e pesada.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>⁠Empresas de transporte coletivo</h3>
                  <p>
                    linhas urbanas e intermunicipais.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>Locadoras de veículos</h3>
                  <p>
                    empresas que trabalham com aluguel de veículos.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 align-self-stretch">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>⁠Seguradoras e corretoras de seguro</h3>
                  <p>
                    que podem oferecer cursos como benefício ou prevenção de risco.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>Polo Universitário</h3>
                  <p>
                    cursos de extensão e parcerias acadêmicas.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>⁠Empresas de RH e consultorias em segurança no trabalho</h3>
                  <p>
                    que precisam de treinamentos para funcionário.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-check" />
                  </div>
                  <h3>⁠Empresas de mineração, florestal, agro e construção civil</h3>
                  <p>
                    que usam máquinas e precisam capacitar operadores e motoristas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
